"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _Section = _interopRequireDefault(require("../components/Section"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function AssetLoader(_ref) {
  var assetId = _ref.assetId;
  return _react.default.createElement("div", {
    className: "section__logo-section__container__loading"
  }, _react.default.createElement("div", {
    key: "".concat(assetId, "-loading"),
    style: {
      width: '142px',
      height: '200px'
    }
  }, _react.default.createElement(_commonReact.ContentLoader, {
    height: "200",
    width: "142"
  }, _react.default.createElement("rect", {
    x: "0",
    y: "0",
    rx: "5",
    ry: "5",
    width: "142",
    height: "142"
  }), _react.default.createElement("rect", {
    x: "0",
    y: "162",
    rx: "4",
    ry: "4",
    width: "142",
    height: "15"
  }), _react.default.createElement("rect", {
    x: "0",
    y: "185",
    rx: "4",
    ry: "4",
    width: "142",
    height: "10"
  }))));
}

function Logos(_ref2) {
  var logosOverview = _ref2.logosOverview,
      logos = _ref2.logos,
      gotoId = _ref2.gotoId,
      setRef = _ref2.setRef;
  return _react.default.createElement(_Section.default, {
    className: "section__logo-section",
    gotoId: gotoId,
    setRef: setRef,
    icon: "typography",
    title: "Logos",
    description: logosOverview,
    emptyText: "Your company has not added any logos yet"
  }, (0, _lodash.default)(logos) ? null : logos.map(function (_ref3) {
    var subBrandGroupId = _ref3.subBrandGroupId,
        name = _ref3.name,
        notes = _ref3.notes,
        assetIds = _ref3.assetIds;
    return (0, _lodash.default)(assetIds) ? null : _react.default.createElement(_react.Fragment, {
      key: subBrandGroupId
    }, _react.default.createElement("h2", null, name), _react.default.createElement("div", {
      className: "container",
      key: subBrandGroupId
    }, _react.default.createElement("div", {
      className: "section__logo-section__container"
    }, assetIds.map(function (assetId) {
      return _react.default.createElement(_commonReact.AssetSelector, {
        key: assetId,
        assetId: assetId
      }, function (asset) {
        if (!asset) {
          return _react.default.createElement(AssetLoader, {
            assetId: assetId
          });
        }

        var _asset$assetFiles = asset.assetFiles,
            assetFiles = _asset$assetFiles === void 0 ? {} : _asset$assetFiles,
            title = asset.title,
            description = asset.description;
        var _assetFiles$ORIGINAL = assetFiles.ORIGINAL;
        _assetFiles$ORIGINAL = _assetFiles$ORIGINAL === void 0 ? {} : _assetFiles$ORIGINAL;
        var _assetFiles$ORIGINAL$ = _assetFiles$ORIGINAL.sourceUrl,
            sourceUrl = _assetFiles$ORIGINAL$ === void 0 ? '' : _assetFiles$ORIGINAL$;
        return _react.default.createElement("div", {
          className: "section__logo-section__container__item"
        }, _react.default.createElement(_uiKit.Image, {
          width: "142px",
          height: "142px",
          imageUrl: sourceUrl
        }), title && _react.default.createElement("h3", null, title), description && _react.default.createElement("p", null, description));
      });
    }))), _react.default.createElement("p", {
      className: "section__logo-section__notes"
    }, notes));
  }).filter(Boolean));
}

var _default = (0, _react.memo)(Logos);

exports.default = _default;